module.exports = __webpack_public_path__ + "img/icon_info_gray.c1db2ce2.svg";